/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'user-face-wink': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" fill-rule="evenodd" d="M10 1.25a8.75 8.75 0 100 17.5 8.75 8.75 0 000-17.5zm0 16.25a7.5 7.5 0 110-15 7.5 7.5 0 010 15zm2.813-10.625a1.563 1.563 0 100 3.125 1.563 1.563 0 000-3.125zM5 8.125h3.75v1.25H5v-1.25zM10 15a5 5 0 004.281-2.431l-1.069-.625a3.75 3.75 0 01-6.425 0l-1.068.625A5 5 0 0010 15z"/>'
  }
})
